// extracted by mini-css-extract-plugin
export default {"root":"authorizing_root__XuNAF"};